import React from "react";
import Sidebar from "../components/Sidebar";
import Dashboard from "../components/Dashboard";

const AdminPanel = () => {
  return (
    <div className="admin-panel">
      <Dashboard />
    </div>
  );
};

export default AdminPanel;
